// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconLinkLocation: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="15" viewBox="0 0 11 15" fill="currentColor">
            <path d="M0,5.50752793 C0,2.44779019 2.46354167,0 5.5,0 C8.53645833,0 11,2.44779019 11,5.50752793 C11,8.97523069 7.5625,13.1423021 6.13020833,14.7158815 C5.78645833,15.0947062 5.21354167,15.0947062 4.86979167,14.7158815 C3.4375,13.1423021 0,8.97523069 0,5.50752793 Z M5.5,7.45993201 C6.50260417,7.45993201 7.33333333,6.61486158 7.33333333,5.594949 C7.33333333,4.57503643 6.50260417,3.729966 5.5,3.729966 C4.49739583,3.729966 3.66666667,4.57503643 3.66666667,5.594949 C3.66666667,6.61486158 4.49739583,7.45993201 5.5,7.45993201 Z" />
        </svg>
    );
};

export default React.memo(IconLinkLocation);
